import axios, { Method } from 'axios';
import { Toast } from 'antd-mobile'

declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>;
  }
}

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 60000, // request timeout
})


// 添加响应拦截器
instance.interceptors.response.use(response => {
  //console.log(response,'fff')
  const res = response.data;
  // 处理海外：token 失效，清除登录信息并跳转到首页，触发登录弹框
  if (process.env.REACT_APP_IDN_ENV === 'hw' && (res?.code === 10101 || res?.code === 10110)) {
    // window.location.href = '/show-status'
    localStorage.removeItem('token');
    localStorage.removeItem('role');  // 清除角色信息
    // 跳转到首页，Layout 会检测到无 token 并自动显示登录弹框
    window.location.href = '/'
    return;
  }
  if (res?.code === 10101) {
    Toast.show({ icon: 'fail', content: '登录失效，将前往登录页' });
    localStorage.removeItem('token');
    setTimeout(() => window.location.href = '/login', 1000)
    return;
  } else if (res?.code === 10110) {
    Toast.show({ icon: 'fail', content: res.msg });
    localStorage.removeItem('token');
    return;
  } else if (res?.code === 0) {
    return res;
  } else if (res?.code) {
    Toast.show({ icon: 'fail', content: res.msg });
    return Promise.reject(new Error(res.message || res.msg || 'Error'));
  }
  return response;

}, error => {
  const message = error.response ? error.response.status : error.message;
  Toast.show({ icon: 'fail', content: message });
  return Promise.reject(error);
});




// 底层请求方法
function baseRequest(method: Method, url: string, opts) {
  const config = { method, url, headers: {}, ...opts };
  const token = localStorage.getItem('token');
  token && (config.headers.token = token);
  return instance(config);
}


export function baseGet(url: string, params?: any) {
  return baseRequest('GET', url, { params });
}

export function basePost(url: string, data?: any) {
  return baseRequest('POST', url, { data });
}

export function noTokenPost(url: string, data?: any, headers: any = {}) {
  return instance({
    method: 'POST',
    url: url,
    data,
    headers
  })
}

// 导入
export function baseImport(url: string, data?: Record<string, any>) {
  return baseRequest('POST', url, { data, headers: { 'Content-Type': 'multipart/form-data' } });
}
